import { requestWrapper } from 'e-submission/domain/data'
import { base64ToBlob } from 'e-submission/utils'

const ecbrSystemizationPrefixPath = 'ecbr-systemization'
const createEcbr = 'create-ecbr-no'
const createEcbrFile = 'create-ecbr-files'
const checkStatusPayment = 'check-status-payment'
const createPaymentAz = 'create-payment-az'

export const submitCreateEcbrNo = (user, payload) => {
  return requestWrapper
    .postRequest(`${ecbrSystemizationPrefixPath}/${createEcbr}`, user, payload)
    .then(({ data }) => data)
}

export const createDownloadEcbrFile = (user, payload) => {
  const ecbrNo = {
    ecbrNo: payload,
  }
  const url = `${ecbrSystemizationPrefixPath}/download-file-ecbr`
  return requestWrapper
    .postRequest(url, user, ecbrNo)
    .then(({ data }) => data)
    .then(({ data, content }) => base64ToBlob(data || content, 'application/pdf'))
}

export const checkPaidQrPaymentStatus = (user, payload = {}) => {
  return requestWrapper.getRequest(`${ecbrSystemizationPrefixPath}/${createEcbr}`, user, payload).then(({ data }) => {
    if (data && data.payerInfo) {
      return { ...data.payerInfo }
    }

    return {
      ecbrNo: null,
      ecbrIssuedDate: null,
      ecbrDate: null,
      ecbrExpiredDate: null,
      ecbrStatus: null,
      messageCode: null,
    }
  })
}

export const createEcbrFiles = (user, payload = {}) => {
  return requestWrapper
    .postRequest(`${ecbrSystemizationPrefixPath}/${createEcbrFile}`, user, payload)
    .then(({ data }) => {
      return data
    })
}

export const checkQrPaying = (user, payload = {}) => {
  return requestWrapper
    .postRequest(`${ecbrSystemizationPrefixPath}/${checkStatusPayment}`, user, payload)
    .then(({ data }) => {
      return data
    })
    .catch(() => {
      return { messageCode: null }
    })
}

export const callCreatePaymentStatusSuccessForQrPayment = (user, payload = {}) => {
  return requestWrapper
    .postRequest(`${ecbrSystemizationPrefixPath}/${createPaymentAz}`, user, payload)
    .then(({ data }) => {
      return data
    })
    .catch(() => {
      return { messageCode: null }
    })
}
